<template>
    <div class="form-box">
        <a-form-model
          class="form-area"
          :class="[`form-${layout}`]"
          ref="ruleForm"
          :label-align="labelAlign"
          :model="form"
          :rules="rules"
          :layout="layout"
          :label-col="labelCol"
          :wrapper-col="wrapperCol">
            <a-form-model-item :label="item.label" :prop="item.key" v-for="(item, i) in controls" :key="i">
                <component
                  :is="item.component"
                  :style="item.style"
                  v-model="form[item.key]"
                  v-bind="item.props"
                  v-on="encapsulationListeners(item.listeners)">
                </component>
            </a-form-model-item>
        </a-form-model>
        <a-space class="footer" v-if="!hideBtn">
            <a-button @click="handleCancel">取消</a-button>
            <a-button type="primary" @click="handleConfirm">{{confirmText}}</a-button>
        </a-space>
    </div>
</template>

<script>
    import {clone} from "../common/js/tool";

    export default {
        name: "form-area",
        props: {
            entity: {
                type: Object,
                default() {
                    return {};
                }
            },
            items: Array,
            extraRules: Object,
            labelCol: Object,
            wrapperCol: Object,
            labelAlign: {
                type: String,
                default: 'left'
            },
            layout: {
                type: String,
                default: 'vertical'
            },
            confirmText: {
                type: String,
                default: '保存'
            },
            hideBtn: Boolean
        },
        data() {
            return {
                controls: [],
                form: {}
            }
        },
        computed: {
            rules() {
                let items = this.controls;
                let rules = {};
                if(items) {
                    items.forEach(item => {
                        if(item.rules) {
                            rules[item.key] = item.rules;
                        }
                    });
                }
                if(this.extraRules) {
                    rules = Object.assign(rules, this.extraRules);
                }
                return rules;
            }
        },
        watch: {
            items(val) {
                this.controls = clone(val);
            },
            entity() {
                this.setForm();
            }
        },
        created() {
            this.controls = clone(this.items);
            this.setForm();
        },
        methods: {
            setForm() {
                const form = clone(this.entity);
                this.form = form;
                this.controls.forEach(item => {
                    if(item.listeners) {
                        for(let key in item.listeners) {
                            let handler = item.listeners[key];
                            const value = item.component === 'a-radio-group' ? {target: {value: form[item.key]}} : form[item.key];
                            handler.call(this, value);
                        }
                    }
                })
            },
            encapsulationListeners(listeners) {
                let res = {};
                for(let key in listeners) {
                    let handler = listeners[key];
                    res[key] = $event => {
                        handler.call(this, $event);
                    }
                }
                return res;
            },
            handleConfirm() {
                return new Promise((resolve, reject) => {
                    this.$refs.ruleForm.validate(valid => {
                        if (valid) {
                            this.$emit("confirm", this.form);
                            resolve(this.form);
                        } else {
                            reject("form error");
                        }
                    });
                })
            },
            handleCancel() {
                this.$emit("cancel");
            }
        }
    }
</script>

<style scoped lang="less">
    .form-box {
        display: flex;
        flex-direction: column;
    }
    .form-area {
        flex: 1;
        padding: 24px;
        overflow: auto;
        &.form-inline {
            padding: 0;
        }
    }

    .footer {
        margin-top: 12px;
        padding: 12px 0;
        border-top: var(--border);
        justify-content: center;
    }
</style>
